import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.assign";
import _classCallCheck from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __rest } from "tslib";
import * as React from 'react';
import { getOUIAProps } from '@patternfly/react-core/dist/js/helpers/ouia';
import { debounce } from '@patternfly/react-core/dist/js/helpers/util';
import styles from '@patternfly/react-styles/css/components/Table/table';
import inlineStyles from '@patternfly/react-styles/css/components/InlineEdit/inline-edit';
import { css } from '@patternfly/react-styles';
export var RowWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(RowWrapper, _React$Component);

  var _super = _createSuper(RowWrapper);

  function RowWrapper(props) {
    var _this;

    _classCallCheck(this, RowWrapper);

    _this = _super.call(this, props);

    _this.handleScroll = function (event) {
      if (!_this._unmounted) {
        _this.props.onScroll(event);
      }
    };

    _this.handleResize = function (event) {
      if (!_this._unmounted) {
        _this.props.onResize(event);
      }
    };

    if (props.onScroll) {
      _this.handleScroll = debounce(_this.handleScroll, 100);
    }

    if (props.onResize) {
      _this.handleResize = debounce(_this.handleResize, 100);
    }

    return _this;
  }

  _createClass(RowWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._unmounted = false;

      if (this.props.onScroll) {
        window.addEventListener('scroll', this.handleScroll);
      }

      if (this.props.onResize) {
        window.addEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._unmounted = true;

      if (this.props.onScroll) {
        window.removeEventListener('scroll', this.handleScroll);
      }

      if (this.props.onResize) {
        window.removeEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          onScroll = _a.onScroll,
          onResize = _a.onResize,
          _a$row = _a.row,
          isExpanded = _a$row.isExpanded,
          isEditable = _a$row.isEditable,
          rowProps = _a.rowProps,
          trRef = _a.trRef,
          className = _a.className,
          ouiaId = _a.ouiaId,
          props = __rest(_a, ["onScroll", "onResize", "row", "rowProps", "trRef", "className", "ouiaId"]);

      return React.createElement("tr", Object.assign({}, props, {
        ref: trRef,
        className: css(className, isExpanded !== undefined && styles.tableExpandableRow, isExpanded && styles.modifiers.expanded, isEditable && inlineStyles.modifiers.inlineEditable),
        hidden: isExpanded !== undefined && !isExpanded
      }, getOUIAProps('TableRow', ouiaId)));
    }
  }]);

  return RowWrapper;
}(React.Component);
RowWrapper.displayName = 'RowWrapper';
RowWrapper.defaultProps = {
  className: '',
  row: {
    isOpen: undefined,
    isExpanded: undefined,
    isHeightAuto: undefined,
    isEditable: undefined
  },
  rowProps: null
};